import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-miss-event-suppoort-doc',
    templateUrl: './miss-event-suppoort-doc.component.html',
    styleUrls: ['./miss-event-suppoort-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MissEventSuppoortDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
